import { useState, useEffect, useCallback } from 'react';
import { OrderCreated, Orders } from '../types';
import OrderService from '../services/order-service';
import { OrderCheckoutData } from '../data/order-check-data';

export const useOrder = () => {
  const [orders, setOrders] = useState<Orders[]>([]);
  const [createdOrder, setCreatedOrder] = useState<OrderCreated>({} as OrderCreated);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createOrder = useCallback(async (orderPayload: OrderCheckoutData) => {

    try {

      const requestId = new Date().getTime().toString();
      
      setLoading(true);
      const { data, message, status } =  await OrderService.createOrder(orderPayload, requestId);

      if (status !== 201) {
        setError(message);
        return ;
      }

      setCreatedOrder(data);
      
    } catch (error) {
      setError((error as Error).message);
    }
    finally {
      setLoading(false);
    }

  }, [])

  useEffect(() => {


    return () => {
      setOrders([]);
      setLoading(false);
      setError(null);
    }
  }, []);

  return { orders, loading, error, createOrder, createdOrder };
};